import React from 'react';
import Heading from '@hubins/components/Heading';
import ShowRawResponse from './ShowRawResponse';
import PepTable from './PepTable';

const PepTemplate = ({ screening }) => {
  return (
    <>
      <div className='flex flex-direction-row space-between align-items-center s-bottom-l'>
        <Heading className='s-top-l' size="4">Hits: <span className={` ${screening.result.hitCount > 0 ? 'c-danger' : 'c-success'}`}>{screening.result.hitCount}</span></Heading>
        <ShowRawResponse screening={screening} />
      </div>
      <PepTable screening={screening} />
    </>
  )
};

export default PepTemplate;